import { JARGON } from "../../modules/constants"
import { COUNTRY } from "../../modules/Countries"

export const map = {
  apptItemProps: ({ a, b, c, d, e, i }) => ({
    index: i,
    nameToSort: b.a,
    apptInfo: {
      renumerationGBP: a.a,
      from: a.b,
      role: a.c,
      position: {
        title: a.d.a,
        type: a.d.b,
        typeBit: a.d.c,
        exec: a.d.d === true ? 0 : a.d.d === false ? 1 : 2,
        indp: a.d.e === true ? 0 : a.d.e === false ? 1 : 2, //independent
      },
      until: a.e,
      tense: a.f,
      tenureYears: a.g,
      tenseBit: a.I,
    },
    personInfo: {
      dateOfBirth: d.a
        ? {
          month: d.a.b,
          year: d.a.c,
        }
        : null,
      sex: d.b,
      age: d.c,
      countryOfResidence: d.d,
      nationality: d.e,
    },
    commonInfo: { name: b.a },
    companyInfo: {
      // TODO: Change aic c.a (front and back) once string c.a - company name has gone from database
      // (Otherwise we will get 'can't convert string to bool' error)
      industry: c.c, // Obsolete - will be replaced by industryBit
      indexBit: c.d,
      countryCode: c.f,
      companyMetaIndex: c.g,
      aic: c.h,
      industryBit: c.i,
    },
    committees: e === null
      ? null : {
        a: e.a, // Audit
        r: e.r, // Remuneration
        n: e.n, // Nomination
      }
  }),
  personItemProps: ({ a, b, c, d, i }) => ({
    isFavourite: false, // Required so we get a favourite column for premium not logged in (eg trial and 350club )
    nameToSort: b.a,
    apptStats: {
      /* Eg the following indicates 1 current, fste 250 role
      counts: {
          0: [0, 1, 0, 0, 0]
          1: [0, 0, 0, 0, 0]
          2: [0, 0, 0, 0, 0]
          3: [0, 0, 0, 0, 0]
      }
      */
      counts: a.a, // [Tense][Index]
      totals: a.b,
      aicCounts: a.c, // Association of Investment Companies member counts [Tense][Index]
    },
    commonInfo: {
      name: b.a.split(", ").reverse().join(' '),
      officerIds: b.b,
    },
    cmteStats: c,
    index: i,
    personInfo: {
      dateOfBirth: d.a
        ? {
          month: d.a.b,
          year: d.a.c,
        }
        : null,
      sex: d.b,
      age: d.c,
      countryOfResidence: d.h.map(c => COUNTRY[c]?.country ?? JARGON.UNKNOWN).join(", "),
      nationality: d.f.map(c => COUNTRY[c]?.nationality ?? JARGON.UNKNOWN).join(", "),
    },
  })
}